export const GET_JOB_TYPES_QUERY = `
  query GetJobTypes($where: job_types_bool_exp = {}) {
    job_types(where: $where, order_by: { created_at: desc }) {
      id
      name
      description
      status
      is_project_based
      status_group
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const GET_JOB_TYPE_BY_ID_QUERY = `
  query GetJobTypeById($id: Int!) {
    job_types_by_pk(id: $id) {
      id
      name
      description
      status
      is_project_based
      status_group
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;
